import api from "../api/axios"

/** URL publique photo membre (via /api pour éviter le fallback SPA sur /uploads/). */
export function memberPhotoUrl(photo) {
  if (!photo) return null
  if (photo.startsWith("http://") || photo.startsWith("https://")) return photo
  const filename = photo.split("/").filter(Boolean).pop()
  if (!filename) return null
  const apiBase = String(api.defaults.baseURL || "/api").replace(/\/$/, "")
  return `${apiBase}/public/member-photo/${encodeURIComponent(filename)}`
}

export const getMembers = async () => {
    const res = await api.get("/members");
    return res.data;
};

export const getMember = async (id) => {
    const res = await api.get(`/members/${id}`);
    return res.data;
};

export const createMember = async (data) => {
    const res = await api.post("/members", data);
    return res.data;
};

export const updateMember = async (id, data) => {
    const res = await api.put(`/members/${id}`, data);
    return res.data;
};

export const deleteMember = async (id) => {
    const res = await api.delete(`/members/${id}`);
    return res.data;
};